import React from "react";
import { ThreeCircles } from "react-loader-spinner";

const FullScreenLoader = () => {
  const loaderOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const loaderStyle = {
    display: "inline-block",
    position: "relative",
    width: "80px",
    height: "80px",
  };

  return (
    <div style={loaderOverlayStyle}>
      <div style={loaderStyle}>
        <ThreeCircles
          height="100"
          width="100"
          color="#1f2732"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
          ariaLabel="three-circles-rotating"
          outerCircleColor=""
          innerCircleColor=""
          middleCircleColor=""
        />
      </div>
    </div>
  );
};

export default FullScreenLoader;
